function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import { EcoOutlined as BaseEcoOutlined } from "sprout-ui-icons";
import { Flex } from "sprout-ui-primitives";
import styled from "styled-components";
const EcoOutlined = styled(BaseEcoOutlined)`
  width: inherit;
  height: inherit;
`;
const Sprout = (props)=>{
    const { url  } = props;
    const as = _objectSpread({}, url && {
        as: Link,
        to: url
    });
    return /*#__PURE__*/ _jsx(Flex, _objectSpread({
        width: "60px",
        height: "60px",
        alignItems: "center",
        justifyContent: "center",
        color: "black.87"
    }, as, {
        children: /*#__PURE__*/ _jsx(EcoOutlined, {})
    }));
};
export default Sprout;
